import { FileText } from 'lucide-react';

export const TermsPage = () => {
  return (
    <div className="min-h-screen pt-20">
      {/* Hero */}
      <section className="py-20 px-6 lg:px-8 bg-gradient-to-br from-slate-50 to-slate-100">
        <div className="max-w-4xl mx-auto text-center">
          <div className="w-16 h-16 bg-teal-50 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <FileText className="w-8 h-8 text-teal-600" />
          </div>
          <h1 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-6">
            Terms of Service
          </h1>
          <p className="text-lg text-slate-600">
            Last updated: January 2025
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 px-6 lg:px-8 bg-white">
        <div className="max-w-4xl mx-auto prose prose-slate prose-lg">
          <h2>Agreement to Terms</h2>
          <p>
            By accessing or using DME R'US platform ("Service"), you agree to be bound by these 
            Terms of Service ("Terms"). If you disagree with any part of these terms, you may 
            not access the Service.
          </p>

          <h2>Description of Service</h2>
          <p>
            DME R'US provides a HIPAA-compliant durable medical equipment management platform 
            that includes patient CRM, order management, supplier integrations, marketing tools, 
            and SEO services.
          </p>

          <h2>User Accounts</h2>
          <p>
            When you create an account, you must provide accurate and complete information. 
            You are responsible for:
          </p>
          <ul>
            <li>Maintaining the security of your account credentials</li>
            <li>All activities that occur under your account</li>
            <li>Notifying us immediately of any unauthorized access</li>
            <li>Ensuring your use complies with applicable healthcare regulations</li>
          </ul>

          <h2>HIPAA Compliance</h2>
          <p>
            Customers who process Protected Health Information (PHI) through our platform must 
            execute a Business Associate Agreement (BAA) with DME R'US. You agree to:
          </p>
          <ul>
            <li>Use the Service in compliance with HIPAA regulations</li>
            <li>Implement appropriate administrative safeguards</li>
            <li>Train your workforce on HIPAA requirements</li>
            <li>Report any security incidents promptly</li>
          </ul>

          <h2>Acceptable Use</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Violate any applicable laws or regulations</li>
            <li>Infringe on intellectual property rights</li>
            <li>Transmit malicious code or interfere with the Service</li>
            <li>Attempt to gain unauthorized access to any systems</li>
            <li>Use the Service for any unlawful purpose</li>
          </ul>

          <h2>Intellectual Property</h2>
          <p>
            The Service and its original content, features, and functionality are owned by 
            DME R'US and are protected by copyright, trademark, and other intellectual property laws.
          </p>

          <h2>Subscription and Payment</h2>
          <p>
            Subscription fees are billed in advance on a monthly or annual basis. You agree to 
            pay all fees associated with your subscription. Failure to pay may result in 
            suspension or termination of your account.
          </p>

          <h2>Data Ownership</h2>
          <p>
            You retain ownership of all data you upload to the Service. By using the Service, 
            you grant us a limited license to process your data solely for the purpose of 
            providing the Service.
          </p>

          <h2>Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, DME R'US shall not be liable for any 
            indirect, incidental, special, consequential, or punitive damages, including 
            loss of profits, data, or business opportunities.
          </p>

          <h2>Indemnification</h2>
          <p>
            You agree to indemnify and hold harmless DME R'US from any claims, damages, or 
            expenses arising from your use of the Service or violation of these Terms.
          </p>

          <h2>Termination</h2>
          <p>
            We may terminate or suspend your account immediately, without prior notice, for 
            conduct that we believe violates these Terms or is harmful to other users, us, 
            or third parties.
          </p>

          <h2>Changes to Terms</h2>
          <p>
            We reserve the right to modify these Terms at any time. We will provide notice 
            of significant changes. Your continued use of the Service after changes become 
            effective constitutes acceptance of the new Terms.
          </p>

          <h2>Contact Us</h2>
          <p>
            For questions about these Terms, please contact us at:
          </p>
          <ul>
            <li>Email: legal@dmerus.com</li>
            <li>Phone: 1-800-DME-HELP</li>
            <li>Address: 11161 E State Rd 70, Ste 110-556, Lakewood Ranch, FL 34202</li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default TermsPage;
